module.exports = __webpack_public_path__ + "static/media/mask.c98ea369.svg";